import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, of, tap } from 'rxjs';
import { IAppConfig } from '../shared/interfaces/app-config';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  config: IAppConfig;
  public configStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private httpClient: HttpClient) {
  }

  public loadConfig(): Observable<IAppConfig | null | Record<string, never>> {
    if (this.config) return of(null);
    return this.httpClient.get<IAppConfig>('./assets/config/config.json').pipe(
      tap((config: IAppConfig) => {
        this.config = config;
        this.configStatus.next(true);
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      catchError((_err: unknown) => {
        this.configStatus.next(false);
        return of({});
      }));
  }

  public getConfig(): IAppConfig {
    return this.config;
  }
}
